"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateItineraryGolfRateMatrix = void 0;
const dayjs = require("dayjs");
const _ = require("lodash");
const models_1 = require("../../models");
const course_1 = require("../course");
const generateItineraryGolfRateMatrix = (active_list, region_courses, formData, public_holidays, course_rates) => {
    const list_to_create = _.cloneDeep(active_list);
    if (!list_to_create)
        return null;
    // reverse the list so the 'best' one is played last
    list_to_create.reverse();
    // filter out selected_courses to only unique courses
    const unique_selected_courses = list_to_create.filter((v, i, a) => a.indexOf(v) === i);
    const filtered_courses = region_courses.filter((course) => unique_selected_courses.includes(course.id));
    // get the date range
    const dates = [];
    const duration = formData.trip?.duration_days_nights || 0;
    const duration_adjustment = formData?.trip?.type === models_1.TripType.GOLF_HOTEL ? 1 : 0;
    // NOTE: If GOLF+HOTEL need to increase the number of days by 1
    for (let i = 0; i < duration + duration_adjustment; i++) {
        dates.push(dayjs(formData.trip?.start_date).add(i, "day").format("YYYY-MM-DD"));
    }
    const getActiveHolidaysForDay = (date, holidays) => {
        if (!holidays)
            return [];
        const active_holidays = holidays.filter((holiday) => {
            if (dayjs(date).isBefore(dayjs(holiday.start_date.toString())))
                return false;
            if (dayjs(date).isAfter(dayjs(holiday.end_date.toString())))
                return false;
            return true;
        });
        return active_holidays;
    };
    const rate_matrix = [];
    dates.forEach((date) => {
        const obj = {
            date: date,
            courses: filtered_courses.map((c) => {
                if (!c)
                    return null;
                if (!c.id)
                    return null;
                // what is the cheapest rate for this date and tee time preference
                const rates = course_rates.filter((r) => r.course_id === c?.id);
                const public_holidays_today = getActiveHolidaysForDay(date, public_holidays);
                const optimised_rate = (0, course_1.getOptimisedCourseRate)({
                    country_id: formData?.trip?.country_id || "",
                    region_id: formData?.trip?.region_id || "",
                    course_rates: rates,
                    course: c,
                    date_of_play: date,
                    caddies: formData?.golf?.golf_extras === models_1.GolfExtras.ALL ? true : false,
                    carts: formData?.golf?.golf_extras === models_1.GolfExtras.ALL ? true : false,
                    course_closures: c.course_closures || [],
                    public_holiday: public_holidays_today?.length > 0,
                    number_of_golfers: formData?.trip?.number_of_golfers || 0,
                    tee_time: {
                        start_time: formData?.golf?.tee_time_preference?.start_time || "",
                        end_time: formData?.golf?.tee_time_preference?.end_time || "",
                    },
                    margin_discount_percentage: formData?.discounts?.margin_discount_percentages?.golf || 0,
                });
                return optimised_rate;
            }),
        };
        // trying top figure out the structure
        rate_matrix.push(obj);
    });
    return rate_matrix;
};
exports.generateItineraryGolfRateMatrix = generateItineraryGolfRateMatrix;
